import React from "react";
import styled from "styled-components";
import { Paper, LinearProgress } from "@mui/material";

const InnerWrapper = styled(Paper)`
  height: 280px;
  width: 320px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  flex-direction: column;
  border: 1px solid #eeeeee;
  border-radius: 28px;
`;

const Wrapper = styled.div`
  width: 100%;
  min-height: 80vh;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const CustomLoader = ({ text = "Loading Module..." }) => {
  return (
    <Wrapper>
      <InnerWrapper>
        <span style={{ fontSize: 14, color: "darkgrey" }}>{text}</span>
        <LinearProgress
          style={{ width: 180, height: 6, borderRadius: 4 }}
          color="secondary"
        />
      </InnerWrapper>
    </Wrapper>
  );
};

export default CustomLoader;
